@if (data$ | async; as data) {
  <app-alerts />

  <app-admin-payment-method-form
    [data]="data"
    [uploadFn]="uploadFn"
    (submitClickEvent)="handleSubmitSuccessEvent($event)" />
} @else {
  <app-spinner-filled />
}
